import { render, staticRenderFns } from "./PostingIndex.vue?vue&type=template&id=2b2dd34e&"
import script from "./PostingIndex.vue?vue&type=script&lang=js&"
export * from "./PostingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports